module.exports = __webpack_public_path__ + "img/home_top2.eae3eae2.jpg";